export const isAllValue = (value) =>
  value?.toLowerCase() === 'all' ? '' : value;

export const filterBuilder = (filter) => {
  const result = {
    startDate: filter?.startDate,
    endDate: filter?.endDate,
    regional: isAllValue(filter?.regional),
    province: isAllValue(filter?.provinceId),
    city: isAllValue(filter?.cityId),
    district: isAllValue(filter?.districtId),
    village: isAllValue(filter?.villageId),
  };

  delete result?.registrationDate;

  return result;
};
